"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = require("../libs/config");

var getTopicType = function getTopicType(prefixId, contentType) {
  if (prefixId === 'beantwoord') {
    return _config.topicTypes.ANSWERED;
  } else if (prefixId === 'vraag') {
    return _config.topicTypes.QUESTION;
  } else if (contentType === 'article') {
    return _config.topicTypes.ARTICLE;
  }

  return _config.topicTypes.DISCUSSION;
};

var _default = getTopicType;
exports.default = _default;